<template>
  <div class="listing-form references-information margin-auto">
    <Card class="references-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-people"/>
        <div><p style="color:#000;font-weight:bold">References</p></div>
      </div>
      <div>
        <Form ref="PreferencesInformationForm" :model="value" label-position="top">
          <FormItem label="Customer references" prop="reference">
            <TinyEditor v-model="value.reference"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import TinyEditor from '@/components/ui/TinyEditor'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    TinyEditor
  }
}
</script>

<style lang="scss" scoped>
.references-information {
  max-width:700px;
  .references-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.references-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
